import React from 'react';
import './CannotConfirmDisputedOrderDrawer.css';

function CannotConfirmDisputedOrderDrawer({ onClose }) {
  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer-content" onClick={(e) => e.stopPropagation()}>
        <h3>Cannot Confirm</h3>
        <p>
          This order is already under dispute.<br />
          Please wait for our team to review and resolve it.
        </p>
        <button className="drawer-black-btn" onClick={onClose}>Understood</button>
      </div>
    </div>
  );
}

export default CannotConfirmDisputedOrderDrawer;
